// extracted by mini-css-extract-plugin
module.exports = {"donationCount":"DonationCount_donationCount__5IKZ3","numbers":"DonationCount_numbers__S3XfP","number":"DonationCount_number__EaQXg","text":"DonationCount_text__tQQsT"};